<template>
    <select :value="value" 
        class="form-control" 
        :required="required"
        @input="e => $emit('input', e.target.value)">
        <option v-for="(option, index) in options" 
            :value="option"
            :key="index">
            {{ option }}
        </option>
    </select>
</template>

<script>
import { availableGenders } from '../helpers'
export default {
    computed: {
        options() {
            return availableGenders()
        }
    },
    props: {
        required: {
            type: Boolean,
            required: false,
            default: false,
        },
        value: {
            type: String,
            required: false,
            default: availableGenders()[0],
        },
    }
}
</script>